import { Post } from "../models/Post";
import { derivePostStatus } from "./postStatus";

// Posts shows publishing activity, not failed content-generation attempts.
export function postsListStatus(
  post: Pick<Post, "status" | "connections">,
): Post["status"] | null {
  if (post.status === "draft" || post.status === "generating") return null;
  const connections = Object.entries(post.connections ?? {}).filter(
    ([, connection]) =>
      connection.status !== "pending" ||
      Boolean(connection.taskName || connection.deferred),
  );
  if (connections.length === 0) {
    // Retain historical published posts whose connections were removed.
    return post.status === "published" ? "published" : null;
  }
  return derivePostStatus(Object.fromEntries(connections));
}
